import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { OrderDto } from '../models/order-dto';
import { StartFetchOrder } from './actions/order.actions';
import { SplitOrder } from '../models/split-order.model';
import { OrderCompleteSucceeded } from '../components/review-step/states/actions/review-step.actions';

export interface SplitOrdersStateModel {
  orderId?: OrderDto['id'];
  splitOrders?: SplitOrder[];
}

const defaultState: SplitOrdersStateModel = {};

@State<SplitOrdersStateModel>({
  name: 'splitOrders',
  defaults: defaultState
})
@Injectable()
export class SplitOrdersState {
  @Selector()
  public static orderId(ctx: SplitOrdersStateModel): OrderDto['id'] | undefined {
    return ctx.orderId;
  }

  @Selector()
  public static splitOrders(ctx: SplitOrdersStateModel): SplitOrder[] | undefined {
    return ctx.splitOrders;
  }

  @Selector()
  public static isAbnRequired(ctx: SplitOrdersStateModel): boolean {
    if (!ctx.orderId) {
      return false;
    }
    return ctx.splitOrders?.some(order => order.isAbnRequired) ?? false;
  }

  @Action(StartFetchOrder)
  public updateState(ctx: StateContext<SplitOrdersStateModel>, { orderId }: StartFetchOrder): void {
    if (orderId !== ctx.getState().orderId) {
      ctx.setState({ ...defaultState, orderId });
      return;
    }
  }

  @Action(OrderCompleteSucceeded)
  public orderCompletedSucceed(ctx: StateContext<SplitOrdersStateModel>, { payload }: OrderCompleteSucceeded): void {
    ctx.patchState({
      splitOrders: payload.splitOrders
    });
  }
}
